export const generateInviteCode = async (): Promise<string> => {
  const RANDOM_BYTE_ARRAY_LENGTH = 13;
  const LENGTH = 12;

  const ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  const BASE = ALPHABET.length;

  function encodeBase58(bytes: Uint8Array): string {
    let value = BigInt(0);
    for (let i = 0; i < bytes.length; i++) {
      value = (value << BigInt(8)) + BigInt(bytes[i]);
    }

    let encoded = "";
    while (value > 0) {
      const remainder = value % BigInt(BASE);
      value /= BigInt(BASE);
      encoded = ALPHABET[Number(remainder)] + encoded;
    }

    return encoded;
  }

  return crypto.subtle.generateKey(
    { name: "AES-GCM", length: 128 }, // Dummy key for randomness
    true,
    ["encrypt", "decrypt"]
  ).then((key) => crypto.subtle.exportKey("raw", key)).then((buffer) => {
    const randomBytes = new Uint8Array(buffer.slice(0, RANDOM_BYTE_ARRAY_LENGTH));
    const base58String = encodeBase58(randomBytes);
    return base58String.slice(0, LENGTH);
  });
}